/**
 * Strip characters that break GCS signed-url generation (spaces / special chars → SigningError 400).
 * Keeps a safe base name and allowlisted extension (e.g. "Glass Animals - Heat Waves.mp3" → "Glass_Animals_-_Heat_Waves.mp3").
 */
export function sanitizeUploadFilename(name: string): string {
  const trimmed = name.trim() || 'file'
  const lastDot = trimmed.lastIndexOf('.')
  const base = lastDot > 0 ? trimmed.slice(0, lastDot) : trimmed
  const rawExt = lastDot > 0 ? trimmed.slice(lastDot + 1) : ''
  const safeBase =
    base
      .replace(/[^a-zA-Z0-9._-]+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^[._]+|[._]+$/g, '')
      .slice(0, 120) || 'file'
  const safeExt = rawExt
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9].*$/, '')
    .slice(0, 10)
  return safeExt ? `${safeBase}.${safeExt}` : safeBase
}
